class TeamMember {
    constructor(el){

        this.data = {
            content: el.dataset.content,
            href: el.getAttribute('href'),
            name: el.dataset.name,
            jobtitle: el.dataset.jobTitle,
            image: el.dataset.image,
            socials: JSON.parse(el.dataset.socials)
        }

        this.popup = {
            wrapper: document.getElementById('team-popup'),
            name: document.getElementById('team-name'),
            image: document.getElementById('team-image'),
            jobtitle: document.getElementById('team-jobtitle'),
            content: document.getElementById('team-content'),
            socials: document.getElementById('team-socials')
        }

        el.addEventListener('click', (e) => this._handleOnClick(e))
    }

    _handleOnClick(e){
        e.preventDefault();

        this._populatePopup();
    }

    _populatePopup(){
        this.popup.name.innerHTML = this.data.name;
        this.popup.content.innerHTML = this.data.content;
        this.popup.jobtitle.innerHTML = this.data.jobtitle;
        this.popup.image.src = this.data.image;
        this.popup.socials.innerHTML = '';

        Object.keys(this.data.socials).forEach((social) => {
            let value = this.data.socials[social];
            
            if(social == 'email') {
                value = 'mailto:' + value;
            }

            let link = document.createElement('a');
            link.setAttribute('class', `social ${social}`);
            link.href = value;

            this.popup.socials.appendChild(link);
        })
    }


}

export { TeamMember }